<section [class.highlight]="viserDetaljer()">
  <button type="button" class="avtalehode" (click)="byttDetaljvisning()">
    <strong>{{ visningsavtale().navn }}</strong>
    <span class="informasjon">
      @if (!visningsavtale().faktureringsinformasjonAngitt) { <span>{{ 'Faktureringsinfo mangler' | translate }}</span> }
      @if (erProeveperiodeUtloept()) { <span>{{ 'Prøveperiode utløpt' | translate }}</span> }
      @if (erIProeveperiode()) { <span>{{ 'Prøveperiode utløper {dato}' | translate:{dato: visningsavtale().proeveperiodeUtloepsdato | zoneddatetimeSomPlaindate | plaindate} }}</span> }
      @if (erTerminert()) { <span>{{ 'Avtale avsluttet' | translate }}</span> }
      <span>{{ '{antall} grupper' | translate:{antall: visningsavtale().antallGrupper} }}</span>
      <span>{{ 'Opprettet {dato}' | translate:{dato: visningsavtale().opprettetDato | zoneddatetimeSomPlaindate | plaindate} }}</span>
    </span>
    <span>{{ 'Kontaktperson {navn} / {epost} / {mobilnummer}' | translate:{navn: visningsavtale().kontaktperson.navnEllerEpost, epost: visningsavtale().kontaktperson.epost, mobilnummer: visningsavtale().kontaktperson.mobilnummer} }}</span>
    <span>
      @for (gruppe of visningsavtale().grupper; track gruppe.id) {
        {{ gruppe.moetenavn }} {{ 'i' | translate }} {{ gruppe.tittel }} ({{ gruppe.organisasjonsnavn }})
      }
    </span>
  </button>

  @if (viserDetaljer() && detaljer(); as avtaledetaljer) {
    <div class="avtaledetaljer" data-testid="avtale-detaljer">
      <div class="handlinger">
        @if (kanRedigereProeveperiode()) {
          <button mat-raised-button color="primary" type="button" class="e2e-redigerproeveperiode" (click)="byttRedigeringAvProeveperiode()">{{ 'Rediger prøveperiode' | translate }}</button>
        }
        @if (!erTerminert()) {
          <button mat-raised-button color="warn" type="button" class="e2e-termineravtale" [disabled]="!kanTerminereAvtale()" (click)="terminerAvtale()">{{ 'Avslutt avtale' | translate }}</button>
        } @else {
          <button mat-raised-button color="primary" type="button" class="e2e-reaktiveravtale" (click)="reaktiverAvtale()">{{ 'Reaktiver avtale' | translate }}</button>
        }
        <button mat-button type="button" (click)="byttVisningAvFakturaOgAvtaleinformasjon()">{{ 'Vis faktura- og avtaleinformasjon' | translate }}</button>
        <button mat-button type="button" (click)="byttVisningAvRedigerAvtale()">{{ 'Rediger avtale' | translate }}</button>
      </div>

      @if (redigererProeveperiode()) {
        <form class="proveperiode" (submit)="$event.preventDefault(); lagreProeveperiode()">
          <label for="proeveperiode-utloepsdato">{{ 'Prøveperiodens utløpsdato' | translate }}</label>
          <input id="proeveperiode-utloepsdato" type="date" [value]="proeveperiodeUtloepsdato()" (input)="proeveperiodeUtloepsdato.set($any($event.target).value)"/>
          <button mat-raised-button color="primary" type="submit">{{ 'Oppdater prøveperiode' | translate }}</button>
        </form>
      }

      @if (erTerminert()) { <p>{{ 'Data slettes {dato}' | translate:{dato: avtaledetaljer.slettesDato | zoneddatetimeSomPlaindate | plaindate} }}</p> }
      @if (avtaledetaljer.laastForRedigering) { <p>{{ 'Låst for redigering' | translate }}</p> }

      @if (viserFakturaOgAvtaleinformasjon()) {
        <section>
          <h3>{{ 'Fakturainformasjon' | translate }}</h3>
          @if (avtaledetaljer.faktureringsinformasjonAngitt) {
            <p>{{ avtaledetaljer.faktureringsinformasjon.adresseLinje1 }}<br/>
              @if (avtaledetaljer.faktureringsinformasjon.adresseLinje2) { {{ avtaledetaljer.faktureringsinformasjon.adresseLinje2 }}<br/> }
              {{ avtaledetaljer.faktureringsinformasjon.postnummer }} {{ avtaledetaljer.faktureringsinformasjon.poststed }}<br/>
              {{ avtaledetaljer.faktureringsinformasjon.epostadresse }}</p>
          } @else { <p>{{ 'Ikke angitt' | translate }}</p> }
        </section>
        <section>
          <h3>{{ 'Avtale' | translate }}</h3>
          <html-formatert [innhold]="avtaledetaljer.aksepterteBetingelser"/>
        </section>
      }

      @if (viserRedigerAvtale()) { <rediger-avtale [avtale]="avtaledetaljer" (vedOppdatert)="vedAvtaleRedigert($event)"/> }

      <section>
        <h3>{{ 'Grupper' | translate }}</h3>
        @for (gruppe of avtaledetaljer.grupper; track gruppe.id) {
          <administrasjon-gruppe [gruppe]="gruppe" [aggregater]="gruppeaggregater().get(gruppe.id) ?? null"/>
        }
      </section>

      <section>
        <h3>{{ 'Brukere' | translate }} ({{ avtaledetaljer.aktiveBrukere.length }})</h3>
        @for (bruker of avtaledetaljer.aktiveBrukere; track bruker.id) {
          <administrasjon-bruker [bruker]="bruker" (brukereKoblet)="lastDetaljer()"/>
        }
      </section>
    </div>
  }
</section>
